import { render, staticRenderFns } from "./SoPromocodes.vue?vue&type=template&id=2a966bcd"
import script from "./SoPromocodes.vue?vue&type=script&lang=js"
export * from "./SoPromocodes.vue?vue&type=script&lang=js"
import style0 from "./SoPromocodes.vue?vue&type=style&index=0&id=2a966bcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports